import SelfReadingValidationResultDTO from 'features/requirements/dtos/SelfReadingValidationResultDTO';
import Alert from 'features/shared/alerts/components/Alert';
import { getAlertType } from 'features/shared/alerts/components/alertHelper';
import { AlertType } from 'features/shared/alerts/enums/alertType';
import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import ValidationMessageDTO from 'features/shared/dtos/ValidationMessageDTO';
import { ValidationMessageType } from 'features/shared/enums/validationMessageType';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  validationResult: SelfReadingValidationResultDTO;
  createRequirementHandler: () => Promise<void>;
}

const SelfReadingValidationSubDialog = ({ validationResult, createRequirementHandler }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // helpers
  const isError = (): boolean => {
    if (validationResult.errors) {
      return validationResult.errors.length > 0;
    }

    return false;
  }

  // handlers
  const closeDialogHandler = () => {
    dialogService.closeDialog();
  }
  
  const confirmSendHandler = () => {
    closeDialogHandler();
    createRequirementHandler();
  }

  // sub-renders
  const renderAlerts = (messages: ValidationMessageDTO[]) => {
    return messages.map((msg, index) => (
      <Alert
        alertObj={{ alertType: getAlertType(msg.type!), message: msg.message }}
        showIconOnMobile={false}
        key={index}
      />
    ));
  };

  const renderButtons = () => {
    if (isError()) {
      return (
        <button className="btn btn-primary ml-2" onClick={() => closeDialogHandler()}>
          {tLabels("selfReadingValidationSubDialog.checkForm")}
        </button>
      );
    } else  {
      return (
        <>
          <button className="btn btn-outline-secondary" onClick={closeDialogHandler}>
            {tLabels("selfReadingValidationSubDialog.fix")}
          </button>
          <button className="btn btn-primary ml-2" onClick={confirmSendHandler}>
            {tLabels("selfReadingValidationSubDialog.send")}
          </button>
        </>
      );
    }
  }

  // render
  return (
    <>
      <div className="p-4">
        {renderAlerts(validationResult.errors!)}
        {renderAlerts(validationResult.warnings!)}
      </div>
      <div className="d-flex justify-content-end px-4 pb-4">
        {renderButtons()}
      </div>
    </>
  )
}

export default SelfReadingValidationSubDialog;
